import React from 'react'

export const DownloadCloud = () => (
  <path
    d='M7.99993 16.9999L11.9999 20.9999M11.9999 20.9999L15.9999 16.9999M11.9999 20.9999L11.9999 11.9999M20.8799 18.0899C21.7493 17.4786 22.4013 16.6061 22.7412 15.5991C23.0811 14.5921 23.0913 13.503 22.7703 12.4898C22.4493 11.4766 21.8138 10.592 20.956 9.96449C20.0982 9.33697 19.0628 8.9991 17.9999 8.99993H16.7399C16.4392 7.82781 15.8764 6.73918 15.0941 5.81601C14.3117 4.89285 13.3301 4.15919 12.2231 3.67029C11.1162 3.18138 9.91278 2.94996 8.70346 2.99345C7.49414 3.03694 6.31045 3.3542 5.24149 3.92136C4.17253 4.48851 3.24616 5.29078 2.53212 6.26776C1.81808 7.24474 1.33498 8.37098 1.11919 9.56168C0.903403 10.7524 0.960543 11.9765 1.28631 13.142C1.61208 14.3074 2.19799 15.3837 2.99993 16.2899'
    strokeLinecap='round'
    strokeLinejoin='round'
  />
)
